import {useEffect, useState} from "react";
import Api from "../../../api";
import { JobProps } from "utils/types";

export interface FiltersProps {
    selectedSort: number,
    favourite: boolean,
    distanceIdx: number,
    rateIdx: number,
    date?: string,
    withDate?: boolean,
}

export const sortOptions = [
    'Newest',
    'Soonest',
    'Closest',
];

export const distanceOptionsUS = [
    'Any Distance',
    '10 miles',
    '25 miles',
    '50 miles',
    '60+ miles',
];

export const distanceOptionsCA = [
    'Any Distance',
    'Within 16 km',
    'Within 40 km',
    'Within 80 km',
    'Within 95 km',
];

export const rateOptsHyg = [
    'All Hourly Rates',
    '$35/hr +',
    '$40/hr +',
    '$45/hr +',
    '$50/hr +',
    '$55/hr +',
];

export const rateOptsAst = [
    'All Hourly Rates',
    '$20/hr +',
    '$24/hr +',
    '$28/hr +',
    '$32/hr +',
    '$35/hr +',
];

const sortByDistance = (jobA: JobProps, jobB: JobProps) => {
    const disA = parseFloat(jobA.distance);
    const disB = parseFloat(jobB.distance);
    return disA > disB
        ? 1
        : disB > disA
            ? -1 : 0;
}

const sortByNewest = (jobA: JobProps, jobB: JobProps) => {
    // postedOn
    const disA = jobA.postedOn;
    const disB = jobB.postedOn;
    return disA < disB
        ? 1
        : disB < disA
            ? -1 : 0;
}

const sortBySoonest = (jobA: JobProps, jobB: JobProps) => {
    // startDate
    const dateA = new Date(jobA.startDate.replace(/-/g, "/") + ' ' + jobA.shifts[0].postedStart);
    const dateB = new Date(jobB.startDate.replace(/-/g, "/") + ' ' + jobB.shifts[0].postedStart);
    return dateA > dateB
        ? 1
        : dateB > dateA
            ? -1 : 0;
}

export const sorting = (selectedSort: number, availableJobs: JobProps[]): JobProps[] => {
    if (selectedSort === 0 && availableJobs.length) {
        return [...availableJobs?.sort(sortByNewest)]
    }
    if (selectedSort === 1 && availableJobs.length) {
        return [...availableJobs?.sort(sortBySoonest)]
    }
    if (selectedSort === 2 && availableJobs.length) {
        return [...availableJobs?.sort(sortByDistance)]
    }
    return [...availableJobs];
}

export const filterByDistance = (distanceIdx: number, jobs: JobProps[]): JobProps[] => {
    const distances = [
        '',
        '16',
        '40',
        '80',
        '95',
    ];

    const parsedDistance = parseFloat(distances[distanceIdx]) || 110;
    return jobs.filter(job => parseFloat(job.distance) <= parsedDistance);
}

export const filterByRate = (status: number, rateIdx: number, jobs: JobProps[], rateOpts: string[]): JobProps[] => {
    let max = 6;
    if(status === 1){
        max += 3
    }
    if(status === 2){
        max += 6
    }

    const parsedRate = parseInt(rateOpts[rateIdx].slice(1)) || 0;
    return jobs.filter(job => job.proposedRate + max >= parsedRate);
}

export function useAvailableJobs(type: number, date?: string): [JobProps[], JobProps[], any, boolean] {
    const [availableJobs, setAvailableJobs] = useState<JobProps[]>([])
    const [errorGetJos, setErrorGetJobs] = useState(null);
    const [loadingJobs, setLoadingJobs] = useState(true);
    const [hidedJobs, setHidedJobs] = useState<JobProps[]>([]);
    async function getAvailableJobs() {
        try {
            const shifts = await Api.getAvailableJobs(type, !!date ? date : undefined);
            let availableShifts = shifts.filter((shift: JobProps) => shift.offer_status !== 3)
            setHidedJobs(availableShifts.filter((shift: JobProps) => shift.isHided));
            setAvailableJobs(availableShifts.filter((shift: JobProps) => !shift.isHided));
            eval(`TempStars.Analytics.track( 'view shifts', {
            shiftStartDate: date ? new Date(moment(date)).toISOString() : '',
            totalShiftsAvailable: availableJobs.length
        } )`);
        } catch (e: any) {
            setErrorGetJobs(e as any);
        } finally {
            setLoadingJobs(false);
        }
    }
    useEffect(() => {
        getAvailableJobs();
    }, [date]);
    return [availableJobs, hidedJobs, errorGetJos, loadingJobs];
}
